import { useMemo, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";

import { useAppSelector } from "../../common/hooks/useStore";
import { selectLocationById, selectLocationsBySearchTerm } from "./locationsSlice";
import NoResultsFound from "../../common/components/noResultsFound/NoResultsFound";
import LocationFilterInput from "./LocationFilterInput";

interface LocationsDropdownProps {
  value?: string;
  disabled?: boolean;
  onChange: (location: string) => void;
}

export default function LocationsDropdown({ value, onChange, disabled }: LocationsDropdownProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const selectedLocation = useAppSelector((state) => (value ? selectLocationById(state, value) : undefined));
  const filteredLocations = useAppSelector((state) => selectLocationsBySearchTerm(state, searchTerm));

  const options = useMemo(() => {
    if (!selectedLocation) {
      return filteredLocations;
    }

    const isSelectedIncluded = filteredLocations.some((loc) => loc.id === selectedLocation.id);
    return isSelectedIncluded ? filteredLocations : [selectedLocation, ...filteredLocations];
  }, [filteredLocations, selectedLocation]);

  return (
    <Dropdown
      optionLabel="name"
      options={options}
      value={selectedLocation}
      filter
      filterTemplate={<LocationFilterInput value={searchTerm} onChange={setSearchTerm} ref={inputRef} />}
      emptyMessage={<NoResultsFound />}
      disabled={disabled}
      onChange={(e) => {
        onChange(e.value.id);
        setSearchTerm("");
      }}
      onShow={() => inputRef.current?.focus({ preventScroll: true })}
      onHide={() => setSearchTerm("")}
    />
  );
}
